<script lang="ts">
  import type { Snippet } from "svelte";
  import type { SvelteHTMLElements } from "svelte/elements";

  import { themeStore } from "$lib/gpu-glossary";

  type Props = SvelteHTMLElements["pre"] & {
    lang?: string | null;
    children?: Snippet;
  };
  let { children, lang }: Props = $props();
</script>

{#if lang}
  <div
    class="code-block rounded border"
    style:background-color={$themeStore.primary[5]}
    style:border-color={$themeStore.primary[20]}
    data-lang={lang}
  >
    <div
      class="text-xs px-3 py-1.5 border-b font-mono rounded-t"
      style:background-color={$themeStore.primary[20]}
      style:border-color={$themeStore.primary[20]}
      style:color={$themeStore.primary[60]}
    >
      {lang}
    </div>
    <pre
      class="p-4 overflow-x-auto font-mono text-sm leading-relaxed m-0 whitespace-pre-wrap break-words"
      style:color={$themeStore.primary[80]}>{@render children?.()}</pre>
  </div>
{:else}
  <pre>{@render children?.()}</pre>
{/if}

<style>
  .code-block {
    margin: 1rem 0;
    transition: border-color 0.2s ease;
  }

  .code-block:hover {
    border-color: #666;
  }
</style>
